export default [
    {
        path: '/bell-curve',
        name: 'bell-curve',
        component: () => import('@/pages/bell-curve/BellCurveParent.vue'),
        meta: {
            dataTablePage: true,
        },
    },
];
